import { Overlay } from '../overlay';
import { ScrollStrategy } from './scroll-strategy';

export abstract class BaseScrollStrategy implements ScrollStrategy {
	protected overlayRef: Overlay;
	protected applied = false;

	attach(overlayRef: Overlay) {
		this.overlayRef = overlayRef;
	}

	enable() {
		if (!this.applied) {
			this.handleEnable();
			this.applied = true;
		}
	}

	disable() {
		if (this.applied) {
			this.handleDisable();
			this.applied = false;
		}
	}

	abstract handleEnable(): void;
	abstract handleDisable(): void;
}
